<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position: relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters
              v-model="filterOptions"
              style="margin-right: 45px"
              @click="refresh"
            />
            <DropdownColumns
              v-model="fields"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
            />
          </div>
          <b-table
            id="raffle-serials-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            stacked="md"
            v-model="copy"
            :items="provider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            tbody-tr-class="tr-pointer"
            v-columns-resizable="{ afterResize: columnsWidthChanged }"
          >
            <template v-slot:empty="scope">
              <div class="text-center">{{ $t(scope.emptyText) }}</div>
            </template>

            <template v-slot:head(code)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(shop_id)="data">{{
              $t(data.label)
            }}</template>
            <template v-slot:head(created)="data">{{
              $t(data.label)
            }}</template>

            <template v-slot:cell(shop_id)="data">
              <span v-if="data.value.to">
                <router-link :to="`/shops/${data.value.to}`">{{
                  data.value.name
                }}</router-link>
              </span>
              <span v-else>{{ data.value.name }}</span>
            </template>

            <template v-slot:cell(created)="data">
              <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
            </template>
          </b-table>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space: nowrap" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{
                      (currentPage - 1) * perPage + 1
                    }}</span>
                    <span slot="end">{{ currentPage * perPage }}</span>
                    <span slot="total">{{ totalRows }}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="
                    $root.$emit('bv::refresh::table', 'raffle-serials-table')
                  "
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import BulkActionSelect from "@/components/BulkActionSelect";
import TableFilters from "@/components/TableFilters";
import moment from "moment";
import timeFormat from "@/shared/timeFormat";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    BulkActionSelect,
    TableFilters,
  },
  name: "raffle-serial",
  mixins: [tableMixin],
  data: function () {
    return {
      tableName: "raffle-serial",

      bulkAction: null,
      bulkActionOptions: [],

      filterOptions: [
        {
          field: "company_id",
          multiple: true,
          placeholder: "Company",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "companies",
          hide_select: true,
          filterOptions: ["tenant_id"],
          options: [],
          selected: [],
        },
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          hide_select: true,
          filterOptions: ["shopgroup_id", "shop_id"],
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map((elem) => elem.eid);
            const orig = data.list[1].originalOptions;
            if (
              selected.length == 0 &&
              data.list[1].options.length != orig.length
            ) {
              data.list[1].options = orig;
            } else if (selected.length != 0) {
              data.list[1].options = orig.filter((item) => {
                if (selected.indexOf(item.ecompany_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          },
        },
        {
          field: "shopgroup_id",
          multiple: true,
          placeholder: "Shop Group",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shopGroups",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptions: ["shop_id"],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map((elem) => elem.eid);
            const index = 2;
            const orig = data.list[index].originalOptions;
            if (selected.length == 0) {
              data.list[index].options = orig;
            } else {
              data.list[index].options = orig.filter((item) => {
                if (selected.indexOf(item.etenant_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          },
        },
        {
          field: "shop_id",
          multiple: false,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",

          options: [],
          originalOptions: [],
          selected: [],
          filterOptionsBy: (data, field, fieldValue) => {
            let selectedTenants = [];
            let selectedShopGroups = [];

            if (field == "tenant_id") {
              selectedTenants = fieldValue.map((elem) => elem.eid);
            } else {
              selectedTenants = data.list[0].selected.map((elem) => elem.eid);
            }
            if (field == "shopgroup_id") {
              selectedShopGroups = fieldValue.map((elem) => elem.eshop_ids);
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            } else {
              selectedShopGroups = data.list[2].selected.map(
                (elem) => elem.eshop_ids
              );
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            }
            const index = 3;
            const orig = data.list[index].originalOptions;

            if (!selectedTenants.length && !selectedShopGroups.length) {
              data.list[index].options = orig;
            } else {
              let tmp = [];

              if (selectedTenants.length) {
                tmp = orig.filter((item) => {
                  if (selectedTenants.indexOf(item.etenant_id) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              if (selectedShopGroups.length) {
                if (!selectedTenants.length && !selectedTenants.length) {
                  tmp = orig;
                }
                tmp = tmp.filter((item) => {
                  if (selectedShopGroups.indexOf(item.eid) > -1) {
                    return true;
                  }
                  return false;
                });
              }
              data.list[index].options = tmp;
            }
          },
        },
        {
          field: "created",
          type: "date",
          opens: "right",
          selected: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day"),
          },
          default: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day"),
          },
          ranges: {
            "Last hour": [moment().subtract(1, "hour"), moment()],
            "Last 6 hours": [moment().subtract(6, "hours"), moment()],
            "Last 24 hours": [moment().subtract(24, "hours"), moment()],
            Today: [moment().startOf("day"), moment().endOf("day")],
            Yesterday: [
              moment().subtract(1, "days").startOf("day"),
              moment().subtract(1, "days").endOf("day"),
            ],
            "This week": [
              moment().startOf("isoWeek"),
              moment().endOf("isoWeek"),
            ],
            "Last week": [
              moment().subtract(1, "week").startOf("isoWeek"),
              moment().subtract(1, "week").endOf("isoWeek"),
            ],
            "This month": [moment().startOf("month"), moment().endOf("month")],
            "Last month": [
              moment().subtract(1, "month").startOf("month"),
              moment().subtract(1, "month").endOf("month"),
            ],
            "This year": [moment().startOf("year"), moment().endOf("year")],
            "Last year": [moment().subtract(1, "year"), moment()],
          },
        },
      ],

      isBusy: false,
      sortBy: "created",
      sortDesc: true,
      fields: [
        {
          key: "eid",
          label: "Id",
          sortable: true,
          ignore: true,
          class: "d-none",
        },
        {
          key: "shop_id",
          label: "Shop",
          sortable: true,
          ignore: true,
          class: "",
        },
        {
          key: "code",
          label: "Code",
          sortable: true,
          class: "",
        },
        {
          key: "created",
          label: "Created at",
          sortable: true,
          ignore: true,
          class: "",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      selected: [],
      copy: null,
      addLabel: "",
    };
  },
  computed: {
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["raffle/endpoint_serials"];

      console.log(
        "exportLink",
        `${apiUrl}/${endpoint}?export=xls&lang=${this.lang}`
      );

      return `${apiUrl}/${endpoint}?export=xls&lang=${this.lang}`;
    },
    exportJson() {
      const fields = [];
      this.fields.forEach((item) => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      console.log("paginationData", paginationData);

      return JSON.stringify(paginationData);
    },
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "raffle-serials-table");
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach((item) => {
        if (item.type != "date" && item.selected.length && !item.postIgnore) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach((el) => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          } else {
            paginationData.dateField = item.field;
            paginationData.dateStart = moment().startOf("day");
            paginationData.dateEnd = moment().endOf("day");
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }
      return paginationData;
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt,
      });

      const paginationData = this.buildPagination();

      const shopByID = this.$store.getters["cache/shopByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "shops").catch((e) => e),
      ])
        .catch((err) => {})
        .finally(() => {
          this.$store
            .dispatch("raffle/fetch_serials", paginationData)
            .then((resp) => {
              this.totalRows = resp.data.total;
              resp.data.rows.forEach((item, index) => {
                if (item.eshop_id) {
                  const data = shopByID(item.eshop_id);
                  if (data) {
                    item.shop_id = {
                      to: item.eshop_id,
                      name: data.name,
                    };
                  } else {
                    item.shop_id = {
                      to: null,
                      name: item.eshop_id,
                    };
                  }
                }
              });
              callback(resp.data.rows);
            })
            .catch((err) => {
              this.$bvToast.toast(
                this.$t(err.message),
                errorConf(this.$t("Error"))
              );
              this.totalRows = 0;
              callback([]);
            })
            .finally(() => {
              loading.close();
            });
        });
      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>

